import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { ClientsFilters } from "@common/schemas/client.schema";
import { FC } from "react";

interface ClientsEmptyViewProps {
    total: number | undefined;
    hasActiveFilters: boolean;
    resetFilters?: () => void;
    updateFilters?: (filters: ClientsFilters) => void;
}

export const ClientsEmptyView: FC<ClientsEmptyViewProps> = ({
    total,
    hasActiveFilters,
    resetFilters,
    updateFilters,
}) => {
    if (total === 0) {
        if (hasActiveFilters) {
            return (
                <EmptyState
                    header="The filters don't match any clients."
                    action={resetFilters}
                />
            );
        }
        return (
            <EmptyState
                header="No clients found"
                action={() => updateFilters?.({ search: "" })}
            />
        );
    }
    return null;
};
